import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import TrustCenter from '../components/trust-center';

interface TrustCenterProcessorElement extends Element {
  props: Element['props'] & {
    dataStructureId: string;
    viewId: string;
    'data-erom-trust-center-data-structure-id': string;
    'data-erom-trust-center-view-id': string;
  };
}

const trustCenter: Processor<TrustCenterProcessorElement> = {
  priority: 10,
  name: 'trust-center',
  test: ({ node }) =>
    !!node.props?.className?.includes('wp-block-erom-trust-center') &&
    !!node.props?.['data-erom-trust-center-data-structure-id'] &&
    !!node.props?.['data-erom-trust-center-view-id'],
  processor: ({ node }) => {
    node.props.dataStructureId = node.props['data-erom-trust-center-data-structure-id'];
    node.props.viewId = node.props['data-erom-trust-center-view-id'];

    node.component = TrustCenter as ComponentType;

    return node;
  }
};

export default trustCenter;
